import { AxiosResponse } from "axios";
import LoginService from "pages/login/login.service";
import { axiosRequest } from "../../../axios/axios.config";
import { ConferenciaVendaLogDTO } from "./conferencia-log.model";

const ConferenciaLogService = () => {
  const path = "/conferenciavenda/log";
  const loginService = LoginService();

  return {
    logs(uuidPedido: string): Promise<AxiosResponse<ConferenciaVendaLogDTO[]>> {
      return axiosRequest.get(`${path}/${uuidPedido}`, {
        headers: loginService.getHeaders(),
      });
    },
  };
};

export default ConferenciaLogService;
